import React, { useEffect, useState } from "react";
import Header from "../Component/Header";
import Footer from "../Component/Footer";
import { useParams } from "react-router-dom";
import Breadcrumb from "../utlis/Breadcrumb";
import { getSubGallery } from "../Service/Api";
const S3_BASE = "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/";
function SubGallery() {
  const { id } = useParams();
  const [data, setData] = useState("");
  const [activeIndex, setActiveIndex] = useState(-1);
  const [zoom, setZoom] = useState(1);
  useEffect(() => {
    if (!id) return;
    const fetchSubGallery = async () => {
      try {
        const res = await getSubGallery(id);
        setData(res);
      } catch (error) {
        console.error("Error fetching sub gallery:", error);
      }
    };
    fetchSubGallery();
  }, [id]);
  const attachments = data?.attachments || [];
  const openImage = (index) => {
    setActiveIndex(index);
    setZoom(1);
    document.body.style.overflow = "hidden";
  };
  const closeImage = () => {
    setActiveIndex(-1);
    setZoom(1);
    document.body.style.overflow = "auto";
  };
  const zoomIn = () => {
    setZoom((prev) => Math.min(prev + 0.25, 3));
  };
  const zoomOut = () => {
    setZoom((prev) => Math.max(prev - 0.25, 0.5));
  };
  const resetZoom = () => {
    setZoom(1);
  };
  const nextImage = () => {
    setActiveIndex((prev) => (prev === attachments.length - 1 ? 0 : prev + 1));
    setZoom(1);
  };
  const previousImage = () => {
    setActiveIndex((prev) => (prev === 0 ? attachments.length - 1 : prev - 1));
    setZoom(1);
  };
  const handleWheel = (e) => {
    e.preventDefault();
    if (e.deltaY < 0) {
      setZoom((prev) => Math.min(prev + 0.15, 3));
    } else {
      setZoom((prev) => Math.max(prev - 0.15, 0.5));
    }
  };
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (activeIndex === -1) return;
      if (e.key === "Escape") {
        closeImage();
      }
      if (e.key === "ArrowRight") {
        nextImage();
      }
      if (e.key === "ArrowLeft") {
        previousImage();
      }
      if (e.key === "+") {
        zoomIn();
      }
      if (e.key === "-") {
        zoomOut();
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      document.body.style.overflow = "auto";
    };
  }, [activeIndex, attachments.length]);
  return (
    <>
      {" "}
      <Header />{" "}
      <div className="InnerSld">
        {" "}
        <Breadcrumb
          img="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/page-title.jpg"
          title="Sub"
          title2="Gallery"
          parentTitle="Gallery"
          parentLink="/gallery"
          path="Sub Gallery"
        />{" "}
      </div>{" "}
      <div className="innerbody">
        {" "}
        <div className="container-fluid">
          {" "}
          <div className="row tabs-dynamics mt-3">
            {" "}
            <div className="col-xxl-3 col-xl-3 col-lg-4 col-md-6 col-12 mb-2">
              {" "}
              <div className="filter-card count-card h-100">
                {" "}
                <p>
                  {" "}
                  <a href="/photo-gallery">
                    {" "}
                    <i className="bi bi-arrow-left"></i> Go Back{" "}
                  </a>{" "}
                </p>{" "}
              </div>{" "}
            </div>{" "}
            <div className="col-xxl-3 col-xl-3 col-lg-4 col-md-6 col-12 mb-2">
              {" "}
              <div className="filter-card count-card h-100">
                {" "}
                <p>
                  {" "}
                  <span>Event Date:</span>{" "}
                  {data?.date
                    ? new Date(data.date).toLocaleDateString("en-GB")
                    : "-"}{" "}
                </p>{" "}
              </div>{" "}
            </div>{" "}
            <div className="col-xxl-3 col-xl-3 col-lg-4 col-md-6 col-12 mb-2">
              {" "}
              <div className="filter-card count-card h-100">
                {" "}
                <p>
                  {" "}
                  <span>Last Update:</span>{" "}
                  {data?.date
                    ? new Date(data.date).toLocaleDateString("en-GB")
                    : "-"}{" "}
                </p>{" "}
              </div>{" "}
            </div>{" "}
            <div className="col-xxl-3 col-xl-3 col-lg-12 col-md-6 col-12 mb-2">
              {" "}
              <div className="filter-card count-card h-100">
                {" "}
                <p>
                  {" "}
                  <span>No. Of Photos:</span> {attachments.length}{" "}
                </p>{" "}
              </div>{" "}
            </div>{" "}
          </div>{" "}
          <div className="row mt-3">
            {" "}
            <div className="col-12">
              {" "}
              <h4 className="sub-gallery-title">{data?.title}</h4>{" "}
              <p>{data?.description}</p>{" "}
            </div>{" "}
          </div>{" "}
          <div className="row" id="photoDetailsContainer">
            {" "}
            {attachments.length > 0 ? (
              attachments.map((img, idx) => (
                <div
                  key={idx}
                  className="col-xl-3 col-lg-4 col-md-6 col-sm-12 gallery-item sub-gallerycount"
                >
                  {" "}
                  <div className="gallery-inner">
                    {" "}
                    <div className="gallery-blk">
                      {" "}
                      <div className="gal-content">
                        {" "}
                        <button
                          type="button"
                          className="sub-gallery-image-btn"
                          onClick={() => openImage(idx)}
                        >
                          {" "}
                          <img
                            className="img-fluid"
                            src={`${S3_BASE}${img}`}
                            alt={`Gallery ${idx + 1}`}
                          />{" "}
                        </button>{" "}
                      </div>{" "}
                    </div>{" "}
                  </div>{" "}
                </div>
              ))
            ) : (
              <div className="col-12 text-center">
                {" "}
                <img
                  src={`${S3_BASE}CSSK/public/Images/dummy.jpg`}
                  alt="No Data"
                  className="img-fluid"
                />{" "}
              </div>
            )}{" "}
          </div>{" "}
        </div>{" "}
      </div>{" "}
      {/* IMAGE ZOOM MODAL */}{" "}
      {activeIndex !== -1 && attachments[activeIndex] && (
        <div className="sub-gallery-lightbox" onClick={closeImage}>
          {" "}
          <div
            className="sub-gallery-viewer"
            onClick={(e) => e.stopPropagation()}
            onWheel={handleWheel}
          >
            {" "}
            {/* CLOSE */}{" "}
            <button
              type="button"
              className="sub-gallery-close"
              onClick={closeImage}
              aria-label="Close"
            >
              {" "}
              <i className="bi bi-x-lg"></i>{" "}
            </button>{" "}
            {/* PREVIOUS */}{" "}
            {attachments.length > 1 && (
              <button
                type="button"
                className="sub-gallery-prev"
                onClick={previousImage}
                aria-label="Previous image"
              >
                {" "}
                <i className="bi bi-chevron-left"></i>{" "}
              </button>
            )}{" "}
            {/* IMAGE */}{" "}
            <div className="sub-gallery-image-wrapper">
              {" "}
              <img
                src={`${S3_BASE}${attachments[activeIndex]}`}
                alt={`Gallery ${activeIndex + 1}`}
                className="sub-gallery-zoom-image"
                style={{ transform: `scale(${zoom})` }}
              />{" "}
            </div>{" "}
            {/* NEXT */}{" "}
            {attachments.length > 1 && (
              <button
                type="button"
                className="sub-gallery-next"
                onClick={nextImage}
                aria-label="Next image"
              >
                {" "}
                <i className="bi bi-chevron-right"></i>{" "}
              </button>
            )}{" "}
            {/* CONTROLS */}{" "}
            <div className="sub-gallery-controls">
              {" "}
              <button type="button" onClick={zoomOut} title="Zoom Out">
                {" "}
                <i className="bi bi-zoom-out"></i>{" "}
              </button>{" "}
              <span>{Math.round(zoom * 100)}%</span>{" "}
              <button type="button" onClick={zoomIn} title="Zoom In">
                {" "}
                <i className="bi bi-zoom-in"></i>{" "}
              </button>{" "}
              <button type="button" onClick={resetZoom} title="Reset Zoom">
                {" "}
                <i className="bi bi-arrow-counterclockwise"></i>{" "}
              </button>{" "}
            </div>{" "}
            {/* IMAGE COUNT */}{" "}
            <div className="sub-gallery-counter">
              {" "}
              {activeIndex + 1} / {attachments.length}{" "}
            </div>{" "}
          </div>{" "}
        </div>
      )}{" "}
      <Footer />{" "}
    </>
  );
}
export default SubGallery;
